import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => {
  const onClickHandler = () => {
    if (props.trackCategory && props.trackAction) {
      window._track(props.trackCategory, props.trackAction);
    }
    props.buttonOnClick();
  };

  return (
    <button
      id={props.id}
      className={props.buttonClass}
      onClick={onClickHandler}
    >
      {props.buttonText}
    </button>
  );
};

Button.propTypes = {
  buttonOnClick: PropTypes.func,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  id: PropTypes.string,
  trackCategory: PropTypes.string,
  trackAction: PropTypes.string,
};

Button.defaultProps = {
  buttonOnClick: () => (true),
  buttonClass: 'btn btn-large btn-success',
  buttonText: 'Success',
  id: '',
  trackCategory: null,
  trackAction: null,
};

export default Button;



// WEBPACK FOOTER //
// ./src-react/Modals/components/Button/index.jsx